import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createSelectionPipeline, type CreateSelectionPipelineRequest } from "@/api/selection-api";

import { SELECTION_PIPELINES_QUERY_KEY } from "./use-selection-pipelines";

export const useCreateSelectionPipeline = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (data: CreateSelectionPipelineRequest) => createSelectionPipeline(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: SELECTION_PIPELINES_QUERY_KEY });
		},
	});

	return {
		mutate: mutation.mutateAsync,
		isPending: mutation.isPending,
		isSuccess: mutation.isSuccess,
		isError: mutation.isError,
		error: mutation.error,
	};
};
